import { render, staticRenderFns } from "./ConnectArtistToTrackDialog.vue?vue&type=template&id=b5ab2f70"
import script from "./ConnectArtistToTrackDialog.vue?vue&type=script&lang=js"
export * from "./ConnectArtistToTrackDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports